export default __webpack_public_path__ + "static/media/20.f621f8e9.jpg";